<section id="privacy-policy-page">
    <div class="privacy-policy-page-title">
        <h3>{{'PRIVACY-POLICY.TEXT' | translate}}</h3>
    </div>
    <div class="privacy-content">
        <section id="text" class="container">
            <span
                [innerHTML]="'privacy-policy-translate' | translate: {entityAddress: entityData.address, entityName: entityData.name, entityRgpd: entityData.rgpd ? entityData.rgpd : entityData.email}"></span>
        </section>
    </div>
</section>